import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  Unplug,
  Instagram,
  RefreshCw,
  ArrowLeft,
  ShieldAlert,
} from "lucide-react";

export default function AccountDisconnected() {
  return (
    <div className="min-h-screen bg-cream">
      <div className="mx-auto flex min-h-screen max-w-7xl items-center justify-center px-6 py-16 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35 }}
          className="w-full max-w-2xl rounded-[2rem] border border-ink/10 bg-white p-8 shadow-sm md:p-12"
          data-testid="account-disconnected-page"
        >
          <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-peach">
            <Unplug
              size={40}
              className="text-hotpink"
              strokeWidth={2.4}
            />
          </div>

          <p className="mt-8 text-center text-xs font-bold uppercase tracking-[0.25em] text-hotpink">
            Instagram Disconnected
          </p>

          <h1 className="mt-3 text-center font-display text-4xl tracking-tighter md:text-5xl">
            Your Instagram
            <br />
            is no longer connected.
          </h1>

          <p className="mx-auto mt-5 max-w-xl text-center text-ink/65">
            Checkout DM no longer has permission to access your Instagram
            Business account. Automation has been paused until you reconnect.
          </p>

          <div className="mt-10 rounded-3xl border border-ink/10 bg-cream p-6">
            <p className="text-sm font-semibold text-ink">
              This usually happens when
            </p>

            <ul className="mt-4 space-y-3 text-sm text-ink/65">
              <li className="flex gap-3">
                <Instagram
                  size={16}
                  className="mt-0.5 flex-none text-hotpink"
                />
                You removed Checkout DM from Instagram or Facebook Business Integrations.
              </li>

              <li className="flex gap-3">
                <ShieldAlert
                  size={16}
                  className="mt-0.5 flex-none text-hotpink"
                />
                Required permissions were revoked.
              </li>

              <li className="flex gap-3">
                <RefreshCw
                  size={16}
                  className="mt-0.5 flex-none text-hotpink"
                />
                Your authorization expired and needs to be renewed.
              </li>
            </ul>
          </div>

          <div className="mt-10 flex flex-col gap-4 md:flex-row">
            <Link
              to="/login"
              data-testid="reconnect-instagram-btn"
              className="cta-glow inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-sunset-gradient px-6 py-3 text-sm font-semibold text-white"
            >
              <Instagram size={16} />
              Reconnect Instagram
            </Link>

            <Link
              to="/"
              data-testid="home-page-btn"
              className="inline-flex flex-1 items-center justify-center gap-2 rounded-full border border-ink/10 bg-white px-6 py-3 text-sm font-semibold text-ink hover:bg-ink/5"
            >
              <ArrowLeft size={16} />
              Back to Home
            </Link>
          </div>

          <div className="mt-8 rounded-2xl bg-mint p-4">
            <p className="font-semibold text-ink">
              Good news
            </p>

            <p className="mt-1 text-sm text-ink/65">
              Your customers, products, analytics and subscription remain
              completely safe. Reconnecting your Instagram account restores your
              automations without affecting your existing data.
            </p>
          </div>

          <p className="mt-8 text-center text-xs text-ink/50">
            After reconnecting, all new messages and automations will continue normally.
          </p>
        </motion.div>
      </div>
    </div>
  );
}